import { Box, Chip, Grid } from '@mui/joy';

import { ReactNode } from 'react';

const TagList = ({
  selectedTags,
}: {
  selectedTags: (string | ReactNode)[];
}) => {
  if (selectedTags.length === 0) return null;
  return (
    <Grid container>
      {selectedTags.map((t, i) => (
        <Box key={i} marginX={0.2} marginY={0}>
          <Chip
            variant={'outlined'}
            color="neutral"
            key={i}
            size="sm"
            sx={{ borderRadius: 4 }}
          >
            {t}
          </Chip>
        </Box>
      ))}
    </Grid>
  );
};

export default TagList;
